import axios from 'axios';
import Api from "./Api";

class EvaluateAPI extends Api{

    getEvaluate(supplierId){
        let path = "/supplier/"  + supplierId + "/evaluate";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

    getEvaluateByUser(supplierId,userId){
        let path = "/supplier/"  + supplierId + "/evaluate/" + userId;
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }


    update(supplierId,userId,data){

        let path = "/supplier/"  + supplierId + "/evaluate/" + userId;
        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._put(endpoint,data)
    }

}

let _api = new EvaluateAPI();

export default _api;